<app-menu-bar></app-menu-bar>

<div class="activate-page">
    <div class="activate-card">
        @switch (state) {
            @case ('loading') {
                <span class="spinner"></span>
                <h2>Activating your account…</h2>
                <p>Please wait a moment.</p>
            }
            @case ('success') {
                <fa-icon [icon]="faCircleCheck" class="icon ok"></fa-icon>
                <h2>Your account is now active</h2>
                <p>You can now successfully log in to your account.</p>
                <a class="cta" routerLink="/">Go to homepage</a>
            }
            @case ('failed') {
                <fa-icon [icon]="faCircleXmark" class="icon fail"></fa-icon>
                <h2>Activation failed</h2>
                <p>There was a problem activating your account. Please check the link in your email, or contact support.</p>
                <a class="cta" routerLink="/">Go to homepage</a>
            }
        }
    </div>
</div>

<app-footer></app-footer>
